import { m } from "@nerves/i18n/messages";
import { cx } from "@/lib/cx";

const shimmer = {
  backgroundImage: "linear-gradient(90deg, transparent 0%, var(--skeleton-shine) 50%, transparent 100%)",
  backgroundSize: "200% 100%",
  animation: "pt-shimmer 1.4s ease-in-out infinite",
} as const;

export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cx("block rounded-control bg-skeleton", className)} style={shimmer} />;
}

const widths = ["w-3/5", "w-2/3", "w-1/2", "w-4/5", "w-2/5"];

/**
 * Row-shaped placeholder for lists on cold load: status glyph, title bar, meta bar. Matches the
 * real row height so content does not jump when data arrives.
 */
export function RowSkeleton({ rows = 6, className }: { rows?: number; className?: string }) {
  return (
    <div role="status" aria-busy="true" className={cx("flex flex-col", className)}>
      <span className="sr-only">{m.common_loading()}</span>
      {Array.from({ length: rows }, (_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder rows
          key={i}
          aria-hidden="true"
          className="flex h-(--row-h) items-center gap-3 border-b border-line px-4"
        >
          <Skeleton className="size-3.5 rounded-full" />
          <Skeleton className="h-2.5 w-12" />
          <Skeleton className={cx("h-2.5", widths[i % widths.length])} />
          <span className="flex-1" />
          <Skeleton className="size-4 rounded-full" />
        </div>
      ))}
    </div>
  );
}
